import type { ReactNode } from "react"
import { HeadContent, Scripts } from "@tanstack/react-router"
import UiProvider from "@holigral/shared/ui/UiProvider"
import { useLocale } from "@holigral/shared/routing"
import { htmlLang } from "@holigral/shared/i18n"
import { ErrorBoundary } from "@holigral/shared/monitoring"
import StoreProvider from "../StoreProvider"
import { AuthWrapper } from "@/auth"

type Props = {
  children: ReactNode
}

export default function Root({ children }: Props) {
  // Reflect the active locale on <html lang> (BCP-47) so the prerendered output
  // and assistive tech see the right language.
  const locale = useLocale()

  return (
    <html lang={htmlLang(locale)}>
      <head>
        <HeadContent />
      </head>
      <body>
        <ErrorBoundary>
          <StoreProvider>
            <UiProvider>
              <AuthWrapper>{children}</AuthWrapper>
            </UiProvider>
          </StoreProvider>
        </ErrorBoundary>
        <Scripts />
      </body>
    </html>
  )
}
